import { FC } from 'react';

import { PaymentsShell } from './shared/payments-shell';
import { PracticePortalFrame } from './shared/practice-portal-frame';

export const PaymentsPage: FC = () => (
  <PaymentsShell title="Payments">
    <PracticePortalFrame path="/Payments?theme=modern" title="Payments" />
  </PaymentsShell>
);
